import { translate } from "../../../core";
import { Form } from "antd";
import { NumericInput } from "../../../core/component";
import styles from "./ItemEntry.module.scss";
import { InputCard } from "./InputCard";

export const ItemFormSales = () => {
  return (
    <InputCard className="py-0 mb-0 mt-4 justify-content-start" contained title={translate("sold")}>
      <table
        className={["table table-borderless mt-2", styles["SoldTable"]].join(" ")}
      >
        <body className="bg-white">
          <tr>
            <td colSpan={2} className="f-xlarge">{translate("year_to_date")}</td>
          </tr>
          <tr>
            <td className={styles.QuantityCaption}>
              {translate("quantity_abbr")}
            </td>
            <td>
              <Form.Item noStyle name={["sales", "yearToDateQuantity"]}>
                <NumericInput
                  decimalPlaces={0}
                  disabled={true}
                  className="w-sm"
                />
              </Form.Item>
            </td>
          </tr>
          <tr>
            <td className={styles.QuantityCaption}>{translate("sales")}</td>
            <td>
              <Form.Item noStyle name={["sales", "yearToDateAmount"]}>
                <NumericInput
                  decimalPlaces={0}
                  disabled={true}
                  className="w-sm"
                />
              </Form.Item>
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="f-xlarge">{translate("last_year_to_date")}</td>
          </tr>
          <tr>
            <td className={styles.QuantityCaption}>
              {translate("quantity_abbr")}
            </td>
            <td>
              <Form.Item noStyle name={["sales", "lastYearQuantity"]}>
                <NumericInput
                  decimalPlaces={0}
                  disabled={true}
                  className="w-sm"
                />
              </Form.Item>
            </td>
          </tr>
          <tr>
            <td className={styles.QuantityCaption}>{translate("sales")}</td>
            <td>
              <Form.Item noStyle name={["sales", "lastYearAmount"]}>
                <NumericInput
                  decimalPlaces={0}
                  disabled={true}
                  className="w-sm"
                />
              </Form.Item>
            </td>
          </tr>
        </body>
      </table>
    </InputCard>
  );
};
